// Item 9 (2026-07): shared event-date formatting.
// - event_date is stored date-only ("YYYY-MM-DD") — render "26 Jul 2026",
//   never a phantom "1:00 am" (new Date("YYYY-MM-DD").toLocaleString()
//   interprets date-only strings as UTC midnight, which is 01:00 in BST).
// - Full datetimes (e.g. gathering starts_at) render "26 Jul 2026, 6:30 pm";
//   an exact-midnight timestamp is treated as "no meaningful start time".
const DATE_ONLY_RE = /^\d{4}-\d{2}-\d{2}$/;

export function formatEventDate(value) {
  if (!value) return "";
  const s = String(value);
  if (DATE_ONLY_RE.test(s)) {
    const d = new Date(`${s}T12:00:00`); // local noon — immune to TZ day-shift
    if (Number.isNaN(d.getTime())) return s;
    return d.toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" });
  }
  const d = new Date(s);
  if (Number.isNaN(d.getTime())) return s;
  const datePart = d.toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" });
  if (d.getHours() === 0 && d.getMinutes() === 0) return datePart;
  const timePart = d.toLocaleTimeString("en-GB", { hour: "numeric", minute: "2-digit", hour12: true }).toLowerCase();
  return `${datePart}, ${timePart}`;
}
